/**
 * IncidentChat - Chat component for incident detail page
 * 
 * Now uses the shared @crm/chat package for unified UI.
 */
import { ChatPanel } from "@crm/chat";

interface IncidentChatProps {
  incidentId: string;
  className?: string;
  defaultExpanded?: boolean;
}

export function IncidentChat({ 
  incidentId, 
  className,
  defaultExpanded = true 
}: IncidentChatProps) {
  return (
    <ChatPanel
      ticketId={incidentId}
      className={className}
      collapsible={true}
      defaultExpanded={defaultExpanded}
    />
  );
}
